// extracted by mini-css-extract-plugin
module.exports = {"root":"ImgDragModal_root__Nz1a_","closeBtn":"ImgDragModal_closeBtn__yNt44","img":"ImgDragModal_img__1O86g","resizeIcon":"ImgDragModal_resizeIcon__1Va9Z"};